import React from "react"
import FormGroup from "../../../Form/FormGroup"
import Textarea from "../../../Form/Textarea"

const AiInstructions = ({ data = {}, onChange = () => { } }) => {
    const handleChangeContent = (name, value) => {
        onChange(name, value)
    }

    return (
        <FormGroup>
            <FormGroup labelText="Sobre a Empresa">
                <Textarea
                    placeholder="Forneça uma breve descrição da empresa, incluindo seu setor, missão e valores."
                    onChange={(e) => handleChangeContent("company_description", e.target.value)}
                    value={data?.company_description || ""}
                    rows={5}
                />
            </FormGroup>
            <FormGroup labelText="Objetivos da IA">
                <Textarea
                    placeholder="Explique o propósito da IA. Ela deve fornecer suporte, gerar leads, responder dúvidas ou realizar vendas?"
                    onChange={(e) => handleChangeContent("ai_objectives", e.target.value)}
                    value={data?.ai_objectives || ""}
                    rows={10}
                />
            </FormGroup>
            <FormGroup labelText="Diretrizes Gerais">
                <Textarea
                    placeholder="Defina o tom da conversa (formal, informal), restrições de resposta e informações que a IA não deve fornecer."
                    onChange={(e) => handleChangeContent("guidelines", e.target.value)}
                    value={data?.guidelines || ""}
                    rows={10}
                />
            </FormGroup>
        </FormGroup>
    )
}

export default AiInstructions